export default "__VITE_ASSET__Yp3fciaG__"